import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCookies } from '../../hooks/useCookies';

const ProtectedRoute = ({ children }) => {
  const { getCookie } = useCookies();
  const admintoken = getCookie('Admintoken')

  return admintoken ? children : <Navigate to="/adminlogin" />;
};

export default ProtectedRoute;
